export interface StudioTarget { id?: string; name?: string; slug?: string; datasetId?: string; kind?: string; status?: string }
export function useStudioActions() {
  const action = useState<string | null>('studio-action', () => null);
  const target = useState<StudioTarget | null>('studio-action-target', () => null);
  function open(name: string, entity?: StudioTarget | null) { target.value = entity ?? null; action.value = name; }
  function close() { action.value = null; target.value = null; }
  return { action, target, open, close };
}
